import { render, staticRenderFns } from "./DinamicTable.vue?vue&type=template&id=2ff92cda&scoped=true&"
import script from "./DinamicTable.vue?vue&type=script&lang=js&"
export * from "./DinamicTable.vue?vue&type=script&lang=js&"
import style0 from "./DinamicTable.vue?vue&type=style&index=0&id=2ff92cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff92cda",
  null
  
)

export default component.exports